<template>
  <div id="templateInfo" class="col-sm-6 col-md-6 col-lg-6">
    
    <div id="explainArea">
      <!-- テンプレート名 -->
      <h3 id="templateName"><CreateplusMessage fcontId="3" v-bind:flinkId="selectedTemplateNumber" msgkey="1" /></h3>
      <!-- テンプレート説明 -->
      <p id="explanation">
        <CreateplusMessage fcontId="3" v-bind:flinkId="selectedTemplateNumber" msgkey="3" />
        <br>
        <CreateplusMessage fcontId="3" v-bind:flinkId="selectedTemplateNumber" msgkey="4" />
      </p>
    

      <!-- Gallery記事へのリンク -->
      <p class="pointer_bt">
        <a v-on:click="clickLink(fcontID)"
          :key="index"
          v-for="(fcontID, index) in selectedFcontID"
          target="_blank" rel="noopener"
        >
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="10" />&nbsp;&raquo;
        </a>
      </p>


      <!-- 公開期限 -->
      <p v-if="(selectedTemplate || {}).expirationDate">
        <CreateplusMessage fcontId="0" flinkId="1" msgkey="4" />&nbsp;{{ dateFormat((selectedTemplate || {}).expirationDate) }}
      </p>

    </div>

    <div id="printButtonArea">
      <!-- 用紙サイズ -->
      <div id="select-papersize">
        <span><CreateplusMessage fcontId="0" flinkId="1" msgkey="5" /></span>:&nbsp;
        <select v-model="selectedSize" name="size" id="size_select">
          <option :key="index" :value="sizeid" v-for="(sizeid, index) in this.usablePaperSizes">
            <CreateplusMessage fcontId="4" v-bind:flinkId="sizeid.toString()" msgkey="1" />
          </option>
        </select>
      </div>

      <div v-if="isBuiltInApp">
        <div id="printButtun">
          <a v-on:click="launchApp()" class="btn btn-info btn-lg btn-wraptxt" role="button">
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="31" />
          </a>
        </div>
      </div>
      <div v-else>
        <!-- アプリ起動ボタン -->
        <div v-if="showPrintButtun" id="printButtun">
          <a v-on:click="launchApp()" class="btn btn-info btn-lg btn-wraptxt" role="button">
            <!-- アプリを起動して印刷する -->
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="6" />
          </a>
        </div>
        <div v-else>
          <p class="info_small">
            <span class="glyphicon glyphicon-info-sign"></span>
            <!-- このコンテンツはスマホアプリ「Epson Creative Print」では印刷出来ません。PCアプリ「Epson Photo＋」をご利用ください。 -->
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="28" />

          </p>
        </div>

        <div v-if="showPrintButtun" id="guidelink">
          <a v-on:click="clickLinkGuide()" class="pointer_bt">
            <!-- アプリが起動しない/コンテンツが開かない時は&nbsp;&raquo; -->
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="30" />&nbsp;&raquo;
          </a>
        </div>
      </div>
    </div>

    <div id="optionArea">
      <!-- クリエイター -->
      <p v-if="hasMessage('3', selectedTemplateNumber, '5')">
        <CreateplusMessage fcontId="0" flinkId="1" msgkey="29" />:&nbsp;<CreateplusMessage fcontId="3" v-bind:flinkId="selectedTemplateNumber" msgkey="5" />
      </p>

      <!-- 版権表示 -->
      <p class="copyright">
        <CreateplusMessage fcontId="3" v-bind:flinkId="selectedTemplateNumber" msgkey="2" />
      </p>

      <!-- テンプレートID -->
      <p id="id"><CreateplusMessage fcontId="0" flinkId="1" msgkey="3" />{{ this.templateid }}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { PAPER_SIZE } from "@/common/contentsinfo";
import { localeDateString } from "@/common/localedate";
import CreateplusMessage from "./CreateplusMessage";
export default {
  name: "CreatePlusTemplate",
  data: function() {
    return {
      selectedSize: PAPER_SIZE.A4
    }
  },
  props: {
    categoryid: String,
    subcategoryid: String,
    templateid: String,
  },
  components: {
    CreateplusMessage,
  },
  computed: {
    ...mapState(["os", "lg2"]),
    ...mapState("createplusMessages", ["createplusMessages"]),
    ...mapState('createplusTemplates', ['createplusCategories', 'createplusCategoriesStatus', 'createplusTemplates', 'createplusTemplatesStatus', 'createplusPaperSizes']),
    ...mapGetters(["isBuiltInApp"]),

    usablePaperSizes: function () {
      if (this.selectedTemplate) {
        this.setSelectedSize(this.selectedTemplate.paperSizeID[0]);
        return this.selectedTemplate.paperSizeID;
      }
      return [];
    },
    isMobile: function () {
      return this.os == "ios" || this.os == "ard";
    },
    selectedTemplate: function () {
      return this.createplusTemplates.find(template => template.templateID === this.templateid);
    },
    selectedTemplateNumber: function () {
      if (this.selectedTemplate) {
        return this.selectedTemplate.templateNumber.toString();
      }
      return "";
    },
    selectedFcontID: function () {
      if (this.selectedTemplate) {
        return this.selectedTemplate.fcontID;
      }
      return [];
    },
    showPrintButtun: function () {
      return !(this.isMobile && this.selectedFcontID[0] == 187)
    },
    browserType: function () {
      return this.isBuiltInApp ? "createplus_internal" : "createplus_external"
    }
  },
  methods: {
    setSelectedSize: function (paperSizeID) {
      this.selectedSize = paperSizeID;
    },
    dateFormat: function (expirationDate) {
      return localeDateString(expirationDate, this.$store.state.lg2)
    },
    clickLink: function (fcontID) {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "galleryhowto_link",
        "custom_parameter2": `${fcontID}`
      })
      
      // BUILTIN_のEXEパラメータはアプリ内ブラウザUIの表示・非表示判定に使用しているため、ギャラリーを呼び出す際にパラメータを変更する
      let exePram = this.$route.query.EXE
      if (exePram == "BUILTIN_CREATIVE") {
        exePram = "CREATIVE_C"
      } else if (exePram == "BUILTIN_PHOTOPLUS"){
        exePram = "PHOTOPLUS_C"
      }

      let resolvedRoute = this.$router.resolve({ 
        path: '/' + this.lg2 + "/articles/" + fcontID,
        query: { EXE: exePram, locale: this.$route.query.locale }
       });
      window.open(resolvedRoute.href);
    },
    clickLinkGuide: function () {
      this.$gtag.event("tap_button", {
        "custom_parameter1": "create_guide"
      })
      this.$router.push({ 
        path: "/createplus/" + this.lg2 + "/templates/guide", hash: "qa",
        query: { EXE: this.$route.query.EXE, locale: this.$route.query.locale } 
      });
    },
    launchApp: function () {
      const paramPaperSizeID = this.createplusPaperSizes.find(param => param.paperSizeID === this.selectedSize);
      let openUrl = "";
      if (this.isMobile) {
        this.$gtag.event("go_app", {
          "app_name": "Creative Print",
          "item_category": this.categoryid,
          "item_category2": this.subcategoryid,
          "item_id": this.templateid,
          "site_id": "create"
        })

        const applink = {
          "design_id": this.templateid,
          "media_size": paramPaperSizeID.paramCreativePrint,
          "source_app" : "Epson.sn_" + this.browserType
        }
        openUrl = this.printCreativePrintUrl(this.os, applink);
      } else {
        this.$gtag.event("go_app", {
          "app_name": "Photo Plus",
          "item_category": this.categoryid,
          "item_category2": this.subcategoryid,
          "item_id": this.templateid,
          "site_id": "create"
        })
        let query = [
          { key: "TID", value: this.templateid },
          { key: "SID", value: paramPaperSizeID.paramPhotoPlus },
          { key: "PID", value: this.browserType }
        ];
        openUrl = this.printPhotoPlusUrl(query);
      }
      window.location = openUrl;
      this.$log.debug("url", openUrl);
    },
    printCreativePrintUrl: function (clientDevice, applink) {
      switch (clientDevice) {
        case "ios": {
          const IOS_URLSCHEME = "com.epson.mobilephone.creative.createplus.v1";
          const BASE_APPOPTION = "print";
          const query = [
            {
              key: "design_id",
              value: applink.design_id,
            },
            {
              key: "media_size",
              value: applink.media_size,
            },
            {
              key: "source_app",
              value: applink.source_app,
            }
          ];
          return this.openIOSURL(IOS_URLSCHEME, BASE_APPOPTION, query);
        }
        case "ard": {
          const ANDROID_URLSCHEME = "com.epson.mobilephone.creative.createplus.v1";
          const ANDROID_PACKAGE = "com.epson.mobilephone.creative"; //S.source_app=Epson.sn.test1";
          const query = [
            {
              key: "S.design_id",
              value: applink.design_id,
            },
            {
              key: "i.media_size",
              value: applink.media_size,
            },
            {
              key: "S.source_app",
              value: applink.source_app,
            }
          ];
          return this.openAndroidURL(ANDROID_URLSCHEME, ANDROID_PACKAGE, query);
        }
      }
    },
    openIOSURL: function (scheme, appoption, query) {
      const IOSquery = query.map((q) => `${q.key}=${q.value}`).join("&");
      const IOS_OPENURL = `${scheme}:///${appoption}?${IOSquery}`;
      return IOS_OPENURL
    },
    openAndroidURL: function (scheme, andpackage, query) {
      const Androidquery = query.map((q) => `${q.key}=${q.value}`).join(";");
      const ANDROID_OPENURL = `intent://#Intent;scheme=${scheme};package=${andpackage};${Androidquery};end;`;
      return ANDROID_OPENURL
    },
    printPhotoPlusUrl: function (queryList) {
      const APP_URL = "com.epson.photoplus://2/";
      const APP_FUNCTION_ID = "edit";
      const pram = queryList.map((q) => `${q.key}=${q.value}`).join("&");
      return `${APP_URL}${APP_FUNCTION_ID}/?${pram}`;
    },
    hasMessage: function (contId, linkId, key) {
      if (this.createplusMessages !== undefined && 
         this.createplusMessages[contId + '-' + linkId + '-' + key] !== undefined) {
        return true
      }
      return false
    },
  }
}
</script>

<style scoped>

#id{
  margin-bottom: 0px;
}

#explainArea {
  margin-top: 5px;
}

#templateName {
  margin-top: 0px;
}

#printButtonArea {
  margin-top: 40px;
}

#optionArea {
  margin-top: 40px;
}

#optionArea p {
  font-size: 12px;
}

#select-papersize{
  margin-top: 15px;
}

#guidelink{
  margin-top: 10px;
}

/* 768px未満 */
@media screen and (max-width: 767px){
  #templateInfo {
    display: flex;
    flex-direction: column;
  }

  #printButtonArea {
    margin-top: 0px;
    order: 1;
  }

  #explainArea {
    margin-top: 40px;
    order: 2;
  }

  #optionArea {
    margin-top: 30px;
    order: 3;
  }
}
</style>